import { Details } from '../models/details.interfaces';

export const DiamondMedallionBannerDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: {
      title: 'SKYMILES #',
      subtitle: '8006270311'
    },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'DIAMOND MEDALLION®',
    level: '0',
    name: 'diamond'
  }
};

export const DiamondMillionMilerMedallionBannerDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: {
      title: 'SKYMILES #',
      subtitle: '8006270311'
    },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'DIAMOND MEDALLION®',
    level: '1',
    name: 'diamond'
  }
};

export const DiamondMedallionBannerWithLifetimeDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'DIAMOND MEDALLION®',
    level: '0',
    name: 'diamond'
  }
};
